import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section id="offer" className="bg-navy text-white pt-10 pb-24 px-4 md:px-8 relative overflow-hidden" data-id="element-113">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-114">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] rounded-full bg-gold/10 blur-[100px]" data-id="element-115"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-116">
        <div className="flex flex-col-reverse md:flex-row items-center gap-8 lg:gap-20" data-id="element-117">
          {/* Left: Image — hidden on mobile to keep price+button above fold */}
          <motion.div className="hidden md:block w-full md:w-1/2 max-w-md mx-auto" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-118">
            <img src="https://cdn.magicpatterns.com/uploads/9HJKBugXqnyyqaj3sf4ns8/Property_Tax_Slayer_English.png" alt="Property Tax Slayer Digital Guide" className="w-full h-auto drop-shadow-2xl rounded-lg" data-id="element-119" />
          </motion.div>

          {/* Right: Offer Stack */}
          <motion.div className="w-full md:w-1/2 text-center md:text-left" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-120">
            <h2 className="text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-121">
              Take Control of Your Finances Today
            </h2>

            <div className="bg-white/5 border border-white/10 rounded-xl p-6 md:p-8 mb-8 backdrop-blur-sm" data-id="element-122">
              <p className="text-xl text-gray-300 mb-6 leading-relaxed line-through decoration-red decoration-2" data-id="element-123">
                You could spend $1,000 on a private appraiser or $2,000 on
                attorney fees.
              </p>
              <p className="text-2xl font-bold text-white mb-2" data-id="element-124">
                Get the complete "Property Tax Slayer" system for just:
              </p>
              <div className="text-6xl md:text-7xl font-bold text-gold mb-4 drop-shadow-md" data-id="element-125">
                $6.39{' '}
                <span className="text-2xl text-gray-400 font-normal" data-id="element-126">USD</span>
              </div>
            </div>

            <CTAButton className="md:items-start" href="https://www.shopdilore.com/cart/53774176420150:1" data-id="element-127" />

            <div className="mt-8 flex items-center justify-center md:justify-start gap-4 text-gray-400 text-sm" data-id="element-128">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/2560px-Visa_Inc._logo.svg.png" alt="Visa" className="h-4 opacity-70 grayscale" data-id="element-129" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/1280px-Mastercard-logo.svg.png" alt="Mastercard" className="h-5 opacity-70 grayscale" data-id="element-130" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/PayPal.svg/2560px-PayPal.svg.png" alt="PayPal" className="h-5 opacity-70 grayscale" data-id="element-131" />
              <span data-id="element-132">256-bit Secure Encryption</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}